import { FunctionComponent } from "react";
import BuyNowButton from "../shared/buy-now-button/buy-now-button";
import H1 from "../shared/html-tags/h1";
import H2 from "../shared/html-tags/h2";
import DIV from "../shared/html-tags/div";

export type Props = {};

const EducationTopBanner: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <div
      className="page-content bg-top-education top-banner"
      style={{ height: "25.25rem" }}
    >
      <div className="inner-content">
        <div
          className="top-left"
          style={{
            display: "flex",
            justifyContent: "stretch",
            alignItems: "center",
            marginLeft: "-8rem",
            paddingLeft: "8rem",
            backgroundImage: "url(/img/news/34-bang-300x300.png)",
            backgroundPosition: "0 17rem",
            backgroundRepeat: "no-repeat",
            backgroundSize: "12.5rem",
            height: "23.5rem",
          }}
        >
          <div>
            <H1 language="de" style={{ lineHeight: "1.25" }}>
              Lerne Datenanalyse mit Leichtigkeit
            </H1>
            <H2
              language="de"
              style={{ fontSize: "1.25rem", marginTop: "0.5rem" }}
            >
              Nutze umfassende Tutorials und Ressourcen als Wegweiser durch SPSS
              und PS IMAGO PRO.
            </H2>
            <BuyNowButton order={"buy"} />
          </div>
        </div>
        <DIV language="de" className="top-right education-banner">
          <img
            src="/img/education/education-480x500.png"
            alt="Roboter lernt über 2x4 PS IMAGO PRO"
            style={{ border: "none", marginTop: "0", maxHeight: "26.25rem" }}
          />
        </DIV>
      </div>
    </div>
  );
};

export default EducationTopBanner;
